import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import SEO from '../../components/SEO';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import { Phone } from 'lucide-react';

const YatraCity = () => {
  const { cityName } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [cityName]);

  const cityRoutes = {
    chandigarh: [
      { destination: 'Takhat Sachkhand Sri Hazur Sahib Nanded', fare: 38000 },
      { destination: 'Hemkund Sahib', fare: 22000 }
    ],
    mohali: [
      { destination: 'Hemkund Sahib', fare: 22000 }
    ],
    rajpura: [
      { destination: 'Hemkund Sahib', fare: 22000 }
    ]
  };

  const routes = cityRoutes?.[cityName?.toLowerCase()] || cityRoutes?.chandigarh;
  const formattedCityName = cityName?.charAt(0)?.toUpperCase() + cityName?.slice(1)?.toLowerCase();

  const handleViewCabs = (destination) => {
    const destinationSlug = destination?.toLowerCase()?.replace(/\s+/g, '-');
    navigate(`/yatra-booking/${cityName?.toLowerCase()}/${destinationSlug}`);
  };

  return (
    <>
      <SEO
        title={`Yatra From ${formattedCityName} - Religious Tour Packages | Advait Tour and Travels`}
        description={`Book yatra packages from ${formattedCityName}. Comfortable pilgrimage travel to Hemkund Sahib, Nanded, and other religious destinations.`}
        keywords={`yatra from ${cityName}, ${cityName} yatra packages, ${cityName} pilgrimage travel`}
        canonicalUrl={`${window.location?.origin}/yatra/${cityName}`}
        ogTitle={`Yatra From ${formattedCityName} - Religious Tour Packages | Advait Tour and Travels`}
        ogDescription={`Book yatra packages from ${formattedCityName}. Comfortable pilgrimage travel to Hemkund Sahib, Nanded, and other religious destinations.`}
        ogUrl={`${window.location?.origin}/yatra/${cityName}`}
        structuredData={{
          "@context": "https://schema.org",
          "@type": "TravelAgency",
          "name": "Advait Tour and Travels",
          "description": `Yatra packages from ${formattedCityName}`
        }}
      />
      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="py-20">
          {/* Hero Section */}
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 py-16 mb-12">
            <div className="container mx-auto px-4">
              <h1 className="text-4xl md:text-5xl font-bold text-white text-center">
                Yatra From {formattedCityName}
              </h1>
            </div>
          </div>

          {/* Route Cards */}
          <div className="container mx-auto px-4 mb-16">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
              {routes?.map((route, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 p-6 hover-lift animate-fade-in-up cursor-pointer"
                  style={{ animationDelay: `${index * 0.1}s` }}
                  onClick={() => handleViewCabs(route?.destination)}
                >
                  <h3 className="text-xl font-bold text-gray-800 mb-3 text-center">
                    {formattedCityName} To {route?.destination}
                  </h3>
                  <p className="text-gray-600 text-center mb-4">
                    Fare Start - ₹{route?.fare?.toLocaleString('en-IN')}
                  </p>
                  <button
                    className="w-full py-3 bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold rounded-lg transition-all duration-300 btn-hover transform hover:scale-105"
                  >
                    VIEW CABS
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Contact Section */}
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 py-12">
            <div className="container mx-auto px-4 text-center">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                We're here for you 24/7!
              </h2>
              <p className="text-xl text-white mb-6">
                Give us a call anytime
              </p>
              <a
                href="tel:+917998666660"
                className="inline-flex items-center gap-3 px-8 py-4 bg-white text-blue-600 font-bold text-2xl rounded-full hover:bg-gray-100 transition-colors duration-300"
              >
                <Phone className="w-6 h-6" />
                +91-79986-66660
              </a>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default YatraCity;